import { createSlice } from '@reduxjs/toolkit'

import { LoaderStateType } from './types'

const initialState: LoaderStateType = {
  isLoading: false,
}

const LoaderSlice = createSlice({
  name: 'Loader',
  initialState,
  reducers: {
    showLoader(state) {
      state.isLoading = true
    },
    hideLoader(state) {
      state.isLoading = false
    },
  },
})

const LoaderSliceReducer = LoaderSlice.reducer

export const { showLoader, hideLoader } = LoaderSlice.actions
export default LoaderSliceReducer
